'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'ranking-star';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e561';
var svgPathData = ['M32 368l0 96c0 8.8 7.2 16 16 16l112 0 0-128-112 0c-8.8 0-16 7.2-16 16zm160-64l0 176 128 0 0-176c0-8.8-7.2-16-16-16l-96 0c-8.8 0-16 7.2-16 16zm13.3-193.6l19.1 19.1c3.6 3.6 5.3 8.7 4.5 13.8l-4.2 26.6 24-12.2 3.5-1.3c3.7-.9 7.5-.5 11 1.3l24 12.2-4.2-26.6c-.8-5 .9-10.2 4.5-13.8l19-19.1-26.6-4.2c-3.8-.6-7.2-2.5-9.7-5.4l-2.1-3.2-12.2-24-12.2 24c-2.3 4.6-6.7 7.7-11.8 8.5l-26.6 4.2zM352 384l0 96 112 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-112 0z', 'M304 256c26.5 0 48 21.5 48 48l0 48 112 0c26.5 0 48 21.5 48 48l0 64-.2 4.9C509.3 493.1 488.9 512 464 512L48 512c-26.5 0-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48l112 0 0-16c0-26.5 21.5-48 48-48l96 0zM48 352c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16l112 0 0-128-112 0zm160-64c-8.8 0-16 7.2-16 16l0 176 128 0 0-176c0-8.8-7.2-16-16-16l-96 0zM352 480l112 0c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-112 0 0 96zM255.8 22.4c6 0 11.5 3.4 14.2 8.8l22.8 44.7 49.5 7.9 2.2 .5c4.9 1.5 8.9 5.3 10.5 10.3 1.9 5.7 .4 12-3.9 16.2l-35.4 35.5 7.8 49.6c.9 5.9-1.5 11.9-6.4 15.4s-11.3 4-16.7 1.3l-44.7-22.8-44.7 22.8c-5.4 2.7-11.8 2.2-16.7-1.3s-7.3-9.5-6.4-15.4l7.8-49.6-35.4-35.5c-4.2-4.3-5.7-10.5-3.9-16.2s6.8-9.9 12.7-10.8l49.5-7.9 22.8-44.7 1.2-1.9c3-4.2 7.8-6.8 13.1-6.8zM243.6 97.6c-2.3 4.6-6.7 7.7-11.8 8.5l-26.6 4.2 19.1 19.1c3.6 3.6 5.3 8.7 4.5 13.8l-4.2 26.6 24-12.2 3.5-1.3c3.7-.9 7.5-.5 11 1.3l24 12.2-4.2-26.6c-.8-5 .9-10.2 4.5-13.8l19-19.1-26.6-4.2c-3.8-.6-7.2-2.5-9.7-5.4l-2.1-3.2-12.2-24-12.2 24z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRankingStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;